// Client-side canvas generator for a shareable AfterBurn impact badge PNG.

const W = 1200;
const H = 630;

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

export async function generateBadgeDataUrl({ name, trees }) {
  try {
    if (document.fonts && document.fonts.ready) await document.fonts.ready;
  } catch (e) {
    console.warn("Font preload skipped:", e);
  }

  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Background
  ctx.fillStyle = "#0A0A0A";
  ctx.fillRect(0, 0, W, H);

  // Forest glow bottom-left
  const g1 = ctx.createRadialGradient(180, H, 40, 180, H, 520);
  g1.addColorStop(0, "rgba(30,63,32,0.55)");
  g1.addColorStop(1, "rgba(10,10,10,0)");
  ctx.fillStyle = g1;
  ctx.fillRect(0, 0, W, H);

  // Ember glow top-right
  const g2 = ctx.createRadialGradient(W - 120, 40, 20, W - 120, 40, 480);
  g2.addColorStop(0, "rgba(255,90,31,0.35)");
  g2.addColorStop(1, "rgba(10,10,10,0)");
  ctx.fillStyle = g2;
  ctx.fillRect(0, 0, W, H);

  // Border frame
  ctx.strokeStyle = "rgba(255,90,31,0.45)";
  ctx.lineWidth = 2;
  roundRect(ctx, 40, 40, W - 80, H - 80, 8);
  ctx.stroke();

  const cx = W / 2;

  // Eyebrow label
  ctx.fillStyle = "#FF5A1F";
  ctx.textAlign = "center";
  ctx.font = "600 24px 'JetBrains Mono', monospace";
  ctx.fillText("A F T E R B U R N   ·   $ A F T B R N", cx, 150);

  if (trees > 0) {
    // Big tree count
    ctx.fillStyle = "#34D399";
    ctx.font = "800 180px 'Cabinet Grotesk', sans-serif";
    ctx.fillText(trees.toLocaleString(), cx, 350);

    ctx.fillStyle = "#F2EFE9";
    ctx.font = "700 44px 'Cabinet Grotesk', sans-serif";
    const who = name ? `trees ${name} is helping plant` : "trees I'm helping plant";
    ctx.fillText(who, cx, 430);
  } else {
    ctx.fillStyle = "#F2EFE9";
    ctx.font = "800 88px 'Cabinet Grotesk', sans-serif";
    ctx.fillText(name ? `${name} joined` : "I joined", cx, 320);
    ctx.fillStyle = "#34D399";
    ctx.font = "700 56px 'Cabinet Grotesk', sans-serif";
    ctx.fillText("the regrowth", cx, 400);
  }

  // Tagline
  ctx.fillStyle = "#8C8A88";
  ctx.font = "500 26px 'JetBrains Mono', monospace";
  ctx.fillText("Turning ashes into forests.", cx, 500);

  // URL
  ctx.fillStyle = "#FF5A1F";
  ctx.font = "700 30px 'Cabinet Grotesk', sans-serif";
  ctx.fillText("after-burn.org", cx, 552);

  return canvas.toDataURL("image/png");
}

export async function downloadBadge({ name, trees }) {
  const url = await generateBadgeDataUrl({ name, trees });
  const a = document.createElement("a");
  a.href = url;
  a.download = trees > 0 ? `afterburn-${trees}-trees.png` : "afterburn-badge.png";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
